import Button from 'components/Button';
import { useCallback } from 'react';
import { flushSync } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { Nav } from 'components/Navigation/NavLayout';

const EditTemplateToolbar = ({
  handleGoBack,
  goBackPath,
  commit,
  commitAsync,
  dirty,
  setDirty,
  title,
}) => {
  const { t } = useTranslation();

  const handleSaveAndClose = useCallback(async () => {
    await commitAsync();
    flushSync(() => {
      setDirty(false);
    });
    handleGoBack();
  }, [commitAsync, setDirty, handleGoBack]);

  return (
    <Nav.Container>
      <Nav.TopNavRow>
        <Nav.TopNavLeftContainer>
          <Nav.TopNavBackButton path={goBackPath} label={t('back')} />
        </Nav.TopNavLeftContainer>
        <Nav.TopNavCenterContainer>
          <Nav.TopNavHeader label={title} />
        </Nav.TopNavCenterContainer>
        <Nav.TopNavRightContainer>
          <Button noSpace disabled={!dirty} onClick={commit}>
            {t('Save')}
          </Button>
          <Button noSpace disabled={!dirty} onClick={handleSaveAndClose}>
            {t('Save & Close')}
          </Button>
        </Nav.TopNavRightContainer>
      </Nav.TopNavRow>
    </Nav.Container>
  );
};

export default EditTemplateToolbar;
